import { Button, CardHeader, Text, useColorMode } from "@chakra-ui/react"
import { useMemo } from "react"
import { FiDownload } from "react-icons/fi"
import { DataToSet } from ".."
import MyCard from "../../../../../Components/micro/Card"
import MachineBreakdown from "./MachineBreakdown"
import MachineHours from "./MachineHours"
import downloadCSV from "../../../../../Components/Exporters/csvDownload"
import Get from "../../../../../Components/Store/hooks/Get"
import { factoryProductionAtom } from "../../../../../Components/Store/atoms"
import lengthFormatter from "../../../../../Components/Functions/formatters/lengthFormatter"
import numberFormatter from "../../../../../Components/Functions/formatters/numberFormatter"
import weightFormatter from "../../../../../Components/Functions/formatters/weightFormatter"
import unitFormatter from "../../../../../Components/Functions/formatters/unitFormatter"
import secFormatter from "../../../../../Components/Functions/formatters/secFormatter"

const Machine = ({
    data,
    isSingleDay,
    dateFrom,
    dateTo
}: {
    data: DataToSet,
    isSingleDay: boolean,
    dateFrom?: string,
    dateTo?: string
}) => {

    return <>
        <MachineTotal data={data} dateFrom={dateFrom} dateTo={dateTo} />
        <MachineHours isSingleDay={isSingleDay} hours={data.machineHours} />
    </>
};

const MachineTotal = ({
    data,
    dateFrom,
    dateTo
}: {
    data: DataToSet,
    dateFrom?: string,
    dateTo?: string
}) => {
    const { colorMode } = useColorMode();
    const productionType = Get(factoryProductionAtom);
    const { border } = useMemo(() => ({
        border: `${colorMode}.border`
    }), [colorMode]);

    const handleDownloadCSV = () => {
        const isMeter = productionType === "meter";

        const headers = [
            "Machine",
            "Mold",
            ...(isMeter ? [] : ["Shots"]),
            "Production",
            "Material",
            "Electricity",
            "Avg Cycletime",
            "On Time",
            "Idle Time",
            "Off Time",
            "Efficiency",
        ];

        const rows = Object.values(data.machines).map((machine) => [
            machine.name,
            (machine.moldName || "").toUpperCase(),
            ...(isMeter
                ? [lengthFormatter(machine.production_meters)]
                : [
                    numberFormatter(machine.shots, "shot(s)"),
                    numberFormatter(machine.production, "pc(s)"),
                ]),
            weightFormatter(machine.material),
            unitFormatter(machine.electricity),
            machine.avgCycletime,
            secFormatter(machine.ontime),
            secFormatter(machine.idletime),
            secFormatter(machine.offtime),
            `${machine.efficiency}%`,
        ]);

        downloadCSV("machine-total.csv", headers, rows);
    };

    return <MyCard p={0}>
        <CardHeader borderBottom={"1px solid"} borderColor={border} display="flex" alignItems="center" justifyContent={"space-between"} px={2} pb={1} pt={3}>
            <Text fontWeight={500} fontSize="lg">Machine Total</Text>
            <Button
                size="sm"
                variant="outline"
                colorScheme="orange"
                leftIcon={<FiDownload />}
                onClick={handleDownloadCSV}
                isDisabled={Object.keys(data.machines).length === 0}
                ml="auto"
                mr={{ base: 0, md: "40%" }}
            >
                CSV
            </Button>
        </CardHeader>
        <MachineBreakdown machines={data.machines} dateFrom={dateFrom} dateTo={dateTo} />
    </MyCard>
}

export default Machine;
export { MachineTotal }
